"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _themeUi = require("theme-ui");

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var DialogActions = function DialogActions(_ref) {
  var props = _extends({}, _ref);

  return (0, _themeUi.jsx)(_themeUi.Flex, _extends({}, props, {
    sx: {
      borderTopWidth: 'thin',
      borderTopStyle: 'solid',
      borderColor: 'neutral.1',
      py: 4,
      px: 5,
      justifyContent: 'flex-end'
    }
  }));
};

var _default = DialogActions;
exports["default"] = _default;